import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Carousel   } from 'antd';


import blank_slider from '../../assets/images/icon/blank_slider.jpg';
import edit from '../../assets/images/icon/edit.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function onChange(a, b, c) {
  console.log(a, b, c);
}

function callback(key) {
  console.log(key);
}




class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/school_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							name: result['data']['0']['name'],
							email: result['data']['0']['email'],
							primary_mobile: result['data']['0']['primary_mobile'],
							secondry_mobile: result['data']['0']['secondry_mobile'],
							type: result['data']['0']['type'],
							country: result['data']['0']['country'],
							city: result['data']['0']['city'],
							locality: result['data']['0']['locality'],
							address: result['data']['0']['address'],
							zipcode: result['data']['0']['zipcode'],
							working_days: result['data']['0']['working_days'],
							timings: result['data']['0']['timings'],
							programs: result['data']['0']['programs'],
							trust_name: result['data']['0']['trust_name'],
							twitter: result['data']['0']['twitter'],
							facebook: result['data']['0']['facebook'],
							website: result['data']['0']['website'],
							youtube: result['data']['0']['youtube'],
							instagram: result['data']['0']['instagram'],
						});
						
					}else{
						this.setState({
							school_list: [],
						});
					}
				}
			});
			getData('franchise/country_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							country_list: result['data'],
						});
					}else{
						this.setState({
							country_list: [],
						});
					}
				}
			});
			
			getData('franchise/school_type',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_type: result['data'],
						});
					}else{
						this.setState({
							school_type: [],
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

	render()

	{
	
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 	 		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">School Profile</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">School Profile
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
            
		   <div class="col s12 m12 ex-padd">
            <div class="container view-Profile viewprograms view-Profile-mobile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 pb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={this.state.name} classname="as" key="1">
						<div class="bb d-flow">
						<div class="col m12 s12 mb-20">
						<Carousel class="mb-20" afterChange={onChange}>
							<div>
							  <img src={blank_slider} />
							</div>
							<div>
							 <img src={blank_slider} />
							</div>
							
						  </Carousel>
						
						</div>
						<div class="col m12 s12  no-padd">
							<div class="col m4 s12">
								<label>School Name</label>
								<input type="text" defaultValue={this.state.name} disabled />
							</div>
							<div class="col m4 s12">
								<label>Locality</label>
								<input type="text"  defaultValue={this.state.locality} disabled />
							</div>
							<div class="col m4 s12">
								<label>City</label>
								<input type="text" defaultValue={this.state.city} disabled />
							</div>
							<div class="col m4 s12">
								<label>Email</label>
								<input type="text"  defaultValue={this.state.email} disabled />
							</div>
							<div class="col m4 s12">
								<label>Primary Mobile</label>
								<input type="text" defaultValue={this.state.primary_mobile} disabled />
							</div>
							<div class="col m4 s12">
								<label>Secondary Mobile</label>
								<input type="text" defaultValue={this.state.secondry_mobile} disabled />
							</div>
							<div class="col m12 s12">
								<label>Address</label>
								<input type="text" defaultValue={this.state.address} disabled />
							</div>
							<div class="col m12 s12">
								<label>Working Days</label>
								<input type="text" defaultValue={this.state.working_days} disabled />
							</div>
							<div class="col m12 s12">
								<label>Timings</label>
								<input type="text" defaultValue={this.state.timings} disabled />
							</div>
							<div class="col m12 s12">
								<label>Program</label>
								<input type="text" defaultValue={this.state.programs}  disabled />
							</div>
							<div class="col m12 s12">
								<label>Trust Name</label>
								<input type="text" defaultValue={this.state.trust_name} disabled />
							</div>
						</div>
						 
						</div>  
						</Panel>
					  </Collapse>
					</div> 
					
					  <div class="children mb-20 iq-card2 bg-color-6">
					  <Collapse defaultActiveKey={['2']} onChange={callback}>
						<Panel header="Follow Us" key="2">
						<div class="bb d-flow pb-20">
						<div class="col m12 s12 no-padd">
							<div class="col m4 s12">
								<label>Twitter Handle</label>
								<input type="text" name="twitter" defaultValue={this.state.twitter}  disabled />
							</div>
							<div class="col m4 s12">
								<label>Facebook Page</label>
								<input type="text" name="facebook" defaultValue={this.state.facebook} disabled />
							</div>
							<div class="col m4 s12">
								<label>Website</label>
								<input type="text" name="website" defaultValue={this.state.website} disabled />
							</div>
							<div class="col m4 s12">
								<label>Youtube Page</label>
								<input type="text" name="youtube" defaultValue={this.state.youtube} disabled />
							</div>
							<div class="col m4 s12">
								<label>Instagram Page</label>
								<input type="text" name="instagram" defaultValue={this.state.instagram} disabled />
							</div>
							
						</div>
						
						 
						</div>  
						
						
						</Panel>
					  </Collapse>
					</div> 
					 
									
					
					<div class="notice-left">
							<Link to={`${process.env.PUBLIC_URL}/school-profile/edit-school`}><img src={edit} /></Link>
						</div>					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
